import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "recipe-view" }
const _hoisted_2 = { class: "recipe-header" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = {
  key: 3,
  class: "tags"
}
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "recipe-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_recipe_metadata = _resolveComponent("recipe-metadata")!
  const _component_recipe_ingredients = _resolveComponent("recipe-ingredients")!
  const _component_recipe_instructions = _resolveComponent("recipe-instructions")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.recipe.pictureUrl)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: _ctx.recipe.pictureUrl,
            alt: _ctx.recipe.title,
            class: "hero-image"
          }, null, 8, _hoisted_3))
        : _createCommentVNode("", true),
      _createElementVNode("h1", null, _toDisplayString(_ctx.recipe.title || 'Untitled Recipe'), 1),
      (_ctx.recipe.author)
        ? (_openBlock(), _createElementBlock("h2", _hoisted_4, [
            _cache[0] || (_cache[0] = _createElementVNode("span", { class: "by" }, "by", -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.recipe.author), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.recipe.createdDate)
        ? (_openBlock(), _createElementBlock("h3", _hoisted_5, _toDisplayString(_ctx.formattedDate), 1))
        : _createCommentVNode("", true),
      (_ctx.recipe.recipeTags && _ctx.recipe.recipeTags.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recipe.recipeTags, (tag) => {
              return (_openBlock(), _createElementBlock("span", {
                class: "tag",
                key: tag
              }, _toDisplayString(tag), 1))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (_ctx.recipe.description)
        ? (_openBlock(), _createElementBlock("div", {
            key: 4,
            class: "description",
            innerHTML: _ctx.parsedDescription
          }, null, 8, _hoisted_7))
        : _createCommentVNode("", true),
      _createVNode(_component_recipe_metadata, {
        prepTime: _ctx.recipe.prepTime,
        cookTime: _ctx.recipe.cookTime,
        servings: _ctx.recipe.servings
      }, null, 8, ["prepTime", "cookTime", "servings"])
    ]),
    _createElementVNode("div", _hoisted_8, [
      (_ctx.recipe.ingredients && _ctx.recipe.ingredients.length)
        ? (_openBlock(), _createBlock(_component_recipe_ingredients, {
            key: 0,
            ingredients: _ctx.recipe.ingredients
          }, null, 8, ["ingredients"]))
        : _createCommentVNode("", true),
      (_ctx.recipe.instructions)
        ? (_openBlock(), _createBlock(_component_recipe_instructions, {
            key: 1,
            instructions: _ctx.recipe.instructions
          }, null, 8, ["instructions"]))
        : _createCommentVNode("", true)
    ])
  ]))
}